import React from 'react';

import type { Order } from '@src/core/buyerApiClient';

import { CashbackGrowthCard } from '../CashbackGrowthCard';
import { CashbackGrowthModal } from '../CashbackGrowthModal';

import { useCashbackGrowthOrchestrator } from './useCashbackGrowthOrchestrator';

export type CashbackGrowthOrchestratorProps = {
  order?: Order;
  renderBanner?: (banner: React.ReactNode) => React.ReactNode;
};

export const CashbackGrowthOrchestrator = (props: CashbackGrowthOrchestratorProps = {}) => {
  const { order, renderBanner } = props;
  const { eligible, snapshot, modalOpen, showBanner, handleDismiss } = useCashbackGrowthOrchestrator({ order });

  if (!eligible || !snapshot) {
    return null;
  }

  const banner = <CashbackGrowthCard snapshot={snapshot} />;
  const wrappedBanner = renderBanner ? renderBanner(banner) : banner;
  const modal = (
    <CashbackGrowthModal
      open={modalOpen}
      orderCode={snapshot.code}
      amountCents={snapshot.amountCents}
      buyerFirstName={snapshot.buyerFirstName}
      onDismiss={handleDismiss}
    />
  );

  return (
    <>
      {showBanner ? wrappedBanner : null}
      {modal}
    </>
  );
};

export default CashbackGrowthOrchestrator;
